import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { PILLARS } from "./data/pillars";
import IntakePage from "./pages/IntakePage";
import GuidedQuestion from "./components/GuidedQuestion";
import ReportPage from "./pages/ReportPage";

// Flatten all questions into a single ordered list for guided mode
const FLAT_QUESTIONS = [];
PILLARS.forEach(pillar => {
  pillar.questions.forEach((q, qi) => {
    FLAT_QUESTIONS.push({ pillar, q, qi });
  });
});

export default function OMLTool() {
  const [phase, setPhase]             = useState("intake");
  const [intake, setIntake]           = useState({ company: "", employees: "", devices: "", vertical: "", rep: "" });
  const [answers, setAnswers]         = useState({});
  const [confidenceMap, setConfidence] = useState({});
  const [flatIdx, setFlatIdx]         = useState(0);
  const [showFramework, setShowFramework] = useState(false);

  // Compute pillar scores
  const pillarScores = {};
  PILLARS.forEach(p => {
    const vals = p.questions.map(q => (answers[q.id] !== undefined ? answers[q.id] + 1 : 1));
    pillarScores[p.id] = vals.reduce((a, b) => a + b, 0) / vals.length;
  });

  const currentFlatQ = FLAT_QUESTIONS[flatIdx];
  const canNext      = answers[currentFlatQ?.q?.id] !== undefined;
  const isLast       = flatIdx === FLAT_QUESTIONS.length - 1;

  const handleAnswer      = (qid, idx) => setAnswers(prev => ({ ...prev, [qid]: idx }));
  const handleConfidence  = (qid, val) => setConfidence(prev => ({ ...prev, [qid]: val }));

  const handleNext = () => {
    if (!canNext) return;
    if (isLast) { setPhase("report"); return; }
    setFlatIdx(i => i + 1);
  };

  const handleBack = () => {
    if (flatIdx === 0) { setPhase("intake"); return; }
    setFlatIdx(i => i - 1);
  };

  const startAssessment = () => {
    if (!intake.company || !intake.employees || !intake.vertical) return;
    setFlatIdx(0);
    setPhase("guided");
  };

  if (phase === "intake") return (
    <IntakePage
      intake={intake} setIntake={setIntake}
      onStart={startAssessment}
      showFramework={showFramework} setShowFramework={setShowFramework}
    />
  );

  if (phase === "guided") return (
    <AnimatePresence mode="wait">
      <GuidedQuestion
        key={flatIdx}
        flatQ={currentFlatQ}
        flatIdx={flatIdx}
        total={FLAT_QUESTIONS.length}
        answers={answers}
        confidenceMap={confidenceMap}
        onAnswer={handleAnswer}
        onConfidence={handleConfidence}
        onBack={handleBack}
        onNext={handleNext}
        canNext={canNext}
      />
    </AnimatePresence>
  );

  return (
    <ReportPage
      intake={intake}
      answers={answers}
      confidenceMap={confidenceMap}
      pillarScores={pillarScores}
      onEdit={() => setPhase("guided")}
    />
  );
}